import init from '../../../js/init';

const name = 'parking-fee-estimator';
const selector = '.parking-fee-estimator';
const formSelector = `${selector}__form`;
const submitButtonSelector = `${selector}__submit button`;
const resetButtonSelector = `${selector}__reset button`;
const tableSelector = `${selector} .table`;
const pricesRowSelector = '.prices-row';
const priceItemLabelSelector = `${pricesRowSelector} :nth-child(1)`;
const priceItemDetailsSelector = `${pricesRowSelector} :nth-child(2)`;
const startDateSelector = `${formSelector} input[name="startDate"]`;
const endDateSelector = `${formSelector} input[name="endDate"]`;
const prebookButtonSelector = `${selector}__estimate button`;
const summaryStartingSelector = `${selector}__summary__starting`;
const summaryEndingSelector = `${selector}__summary__ending`;

Drupal.t = s => s;
// prettier-ignore
export const DEFAULT_PARKING_PRICES = [
  { "title": "Cell Phone Waiting Lot", "breakdown": [{ "price": 0 }] },
  {
    "title": "Lot 2 General",
    "breakdown": [
      { "minutes": 30, "price": 3 },
      { "minutes": 60, "price": 6 },
      { "minutes": 120, "price": 8 },
      { "minutes": 240, "price": 10 },
      { "minutes": 1440, "price": 21 },
      { "price": 21 }
    ]
  },
  {
    "title": "Lot 2 Premium",
    "breakdown": [
      { "minutes": 60, "price": 8 },
      { "minutes": 120, "price": 10 },
      { "minutes": 1440, "price": 27 },
      { "price": 27 },
    ]
  },
  { "title": "Lot 3", "breakdown": [{ "price": 16 }] },
  { "title": "Lot 5", "breakdown": [{ "price": 13 }] },
  {
    "title": "Lot 4 General",
    "breakdown": [
      { "minutes": 30, "price": 3 },
      { "minutes": 60, "price": 6 },
      { "minutes": 120, "price": 8 },
      { "minutes": 240, "price": 10 },
      { "minutes": 1440, "price": 21 },
      { "price": 21 },
    ]
  },
  {
    "title": "Lot 4 Premium",
    "breakdown": [
      { "minutes": 60, "price": 8 },
      { "minutes": 120, "price": 10 },
      { "minutes": 1440, "price": 27 },
      { "price": 27 },
    ]
  }
];

DEFAULT_PARKING_PRICES.forEach(
  c => c.breakdown && c.breakdown.sort((a, b) => a.minutes - b.minutes)
);

init(Drupal, name, selector, root => {
  const tableElem = root.querySelector(tableSelector);
  const form = root.querySelector(formSelector);
  const prebookButton = root.querySelector(prebookButtonSelector);
  const submitButton = root.querySelector(submitButtonSelector);
  const resetButton = root.querySelector(resetButtonSelector);
  const startDateInput = root.querySelector(startDateSelector);
  const endDateInput = root.querySelector(endDateSelector);
  const summaryStartingContainer = root.querySelector(summaryStartingSelector);
  const summaryEndingContainer = root.querySelector(summaryEndingSelector);

  let categories = DEFAULT_PARKING_PRICES;

  if (root.hasAttribute('data-prices')) categories = JSON.parse(root.getAttribute('data-prices'));

  const formatTime = price => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price);
  };

  const getPrice = (minutes, breakdown) => {
    if (!breakdown || (breakdown.length === 1 && breakdown[0].price === 0)) return 'Free';
    if (minutes === 0) return formatTime(0);

    let i = 0;
    while (breakdown[i].minutes < minutes) i++;

    let price = breakdown[i].price;

    if (breakdown[i].minutes === undefined) {
      // (Up to 24 hours price) + ( days - 1 ) * (additional days price)
      if (minutes > 1440)
        price = (breakdown.length > 1 ? breakdown[i - 1].price : breakdown[i].price) + (Math.ceil(minutes / 1440) - 1) * breakdown[i].price;
    }

    return formatTime(price);
  };

  const initTable = () => {
    const priceRows = tableElem.querySelectorAll(pricesRowSelector);

    const items = categories.map(({ title, breakdown }, idx) => {
      const item = priceRows[idx];

      const label = item.querySelector(priceItemLabelSelector);
      const details = item.querySelector(priceItemDetailsSelector);

      label.innerHTML = title;
      details.innerHTML = getPrice(0, breakdown);

      return item.outerHTML;
    });

    tableElem.innerHTML = items.join('');
  };

  const getFormValues = () => {
    const values = {};
    const formData = new FormData(form);
    for (const [key, value] of formData.entries()) values[key] = value;
    return values;
  };

  const updatePrices = minutes => {
    const priceRows = tableElem.querySelectorAll(pricesRowSelector);

    categories.forEach((c, idx) => {
      const detailsElem = priceRows[idx].querySelector(priceItemDetailsSelector);
      detailsElem.innerHTML = `${getPrice(minutes, c.breakdown)}`;
    });
  };

  const calculate = e => {
    e.preventDefault();

    const { startDate, startTime, endDate, endTime } = getFormValues();

    const [startYear, startMonth, startDay] = startDate.split('-').map(num => +num);
    const [startHour, startMinutes] = startTime.split(':').map(num => +num);
    const [endYear, endMonth, endDay] = endDate.split('-').map(num => +num);
    const [endHour, endMinutes] = endTime.split(':').map(num => +num);

    const startDateObj = new Date(startYear, startMonth - 1, startDay, startHour, startMinutes);
    const endDateObj = new Date(endYear, endMonth - 1, endDay, endHour, endMinutes);

    const diffMills = endDateObj.getTime() - startDateObj.getTime();

    const diffMinutes = diffMills / 1000 / 60;

    updatePrices(diffMinutes);
    prebookButton.disabled = false;
    var options = { month: 'long', day: '2-digit', year: 'numeric', minute: '2-digit', hour: '2-digit' };
    summaryStartingContainer.innerHTML = startDateObj.toLocaleDateString("en-US", options);
    summaryEndingContainer.innerHTML = endDateObj.toLocaleDateString("en-US", options);

    resetButton.classList.remove('hidden');
  };

  const prebook = e => {
    e.preventDefault();

    const { startDate, startTime, endDate, endTime, terminal } = getFormValues();

    const [startYear, startMonth, startDay] = startDate.split('-').map(num => +num);
    const [endYear, endMonth, endDay] = endDate.split('-').map(num => +num);

    const query = {
      ac: 'ONT',
      ad: startMonth + '/' + startDay + '/' +startYear,
      at: startTime,
      dd: endMonth + '/' + endDay + '/' +endYear,
      dt: endTime,
      t: terminal
    }
    const queryString = Object.keys(query).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
    }).join('&');

    window.open('https://booking.flyontario.com/en/search-results/?' + queryString, '_blank');
  };

  const updateButtons = () => {
    const values = getFormValues();
    delete values.terminal;
    resetButton.classList.add('hidden');
    submitButton.disabled = Object.values(values).some(v => !v);
  };

  const resetPrices = () => {
    requestAnimationFrame(updateButtons);
    updatePrices(0);
    prebookButton.disabled = true;
    summaryStartingContainer.innerHTML = '';
    summaryEndingContainer.innerHTML = '';
  };

  const addListeners = () => {
    form.onsubmit = calculate;
    form.onchange = resetPrices;
    form.onreset = resetPrices;
    prebookButton.onclick = prebook;
  };

  const manageInputs = () => {
    const currDate = new Date();
    const currDateStr = currDate.toLocaleDateString('en-ca');
    startDateInput.setAttribute('min', currDateStr);
    endDateInput.setAttribute('min', currDateStr);

    startDateInput.addEventListener('change', () => {
      const startDate = new Date(startDateInput.value);
      const endDate = new Date(endDateInput.value);

      if (!startDate) return;

      endDateInput.setAttribute('min', startDate.toLocaleDateString('en-ca'));

      if (!endDate) return;


      if (startDate.getTime() > endDate.getTime()) {
        endDateInput.value = startDateInput.value;
      }
    });
  };

  initTable();
  addListeners();
  manageInputs();
});
